/// <reference path="../../../../../../../rcwebmodels/gensetcommands.cs.d.ts" />
/// <reference path="../../../../../../../rcwebmodels/dryforwardcommandparams.cs.d.ts" />
import * as React from 'react';
import { DryCommandsGrid } from '../../../childcomponents/DryCommandsGrid';
import { RCUtils } from './../../../../RCUtils';
import { PopupWindow } from '../../../sharedcomponents/PopupWindow';
import { DryStatusSSRMGrid } from '../../../childcomponents/DryStatusSSRMGrid';
import DryStatus from '../../../routecomponents/DryStatusSSRM';

import $ from 'jquery';
var self;
var Config: any = require('../../../../Config.json');

export interface ReportingIntervalState {
    SelectedDrys: any[],
    RowData: server.DryStatusData[],
    Filters: server.DryForwardCommandParams
}

export class MRelatedReportingInterval extends React.Component<any, ReportingIntervalState> {
    constructor(props: any) {
        super(props);
        var filterSet = this.setDefaultFilters();
        this.state = { SelectedDrys: [], RowData: [], Filters: filterSet };
    }

    componentDidMount() {

        if (this.props.dryData != null && this.props.dryData.length > 0) {
            this.setState({ RowData: this.props.dryData });
        }
    }

    submitPingCommand() {
        var command = "PollUnit";
        var refreshGrid = this.props.refreshGrid;
        //this.submitCommands(command, null, refreshGrid);
    }
    ValidateDecimalValue(param) {
        const IsMatch = /^[-+]?[0-9]*\.?[0-9]*([eE][-+]?[0-9]+)?$/;
        if (IsMatch.test(param))
            return true;
        else
            return false;
    }
    submitReportingIntervalCommand() {
        var AlertMessage = "";
        var motionReportingInterval = this.state.Filters.InMotionReportingInterval.toString();
        var stationaryreportingInterval = this.state.Filters.StationaryReportingInterval.toString();
        if ((!motionReportingInterval || motionReportingInterval == undefined || motionReportingInterval == "" || motionReportingInterval.length == 0) || !this.ValidateDecimalValue(motionReportingInterval))
            AlertMessage += "Please enter valid InMotionReportingInterval value.\n";
        if ((!stationaryreportingInterval || stationaryreportingInterval == undefined || stationaryreportingInterval == "" || stationaryreportingInterval.length == 0) || !this.ValidateDecimalValue(stationaryreportingInterval))
            AlertMessage += "Please enter valid StationaryReportingInterval value.\n";
        if (AlertMessage == '') {


            //if (self.state.rowData.length > 0) {
            var command = "MotionReportingInterval";
            $('#globalLoader').show();
            var refreshGrid = this.props.refreshGrid;
            this.state.Filters.CommandName = command;
            this.state.Filters.SelectedDrys = this.state.RowData;
            // self.state.Filters.TempValue = paramValue;
            var forwardCommandParams = JSON.stringify(this.state.Filters);

            var request = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/Asset/DryPostForwardCommands', { method: 'POST', body: forwardCommandParams, headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
            fetch(request)
                .then(RCUtils.handleError)
                .then(response => response.json() as Promise<ValidationSeverityResult>)
                .then(data => {
                    if (data != null && data != undefined) {
                        if (data.Result != null && data.Result != undefined && data.Result.length > 0) {
                            PopupWindow.showErrorMessage("Error", data.Result);
                            $(".mm-popup__box__body").css("white-space", "pre-line");
                            $('#globalLoader').hide();
                            return;
                        }
                    }

                    if ($('#confirmPopUpModel') != undefined) {
                        $("#confirmPopUpModel .btn-close").click();
                    }

                    $("#contextMenuModel .close").click();

                    if (refreshGrid == "home")
                        DryStatusSSRMGrid.refreshDashboardGrid();
                    else
                        DryStatus.refreshDryStatusGrid();
                });
            this.setDefaultFilters();
        }
        else {
            PopupWindow.showErrorMessage('Error', AlertMessage);
        }
        //}
        //else
        //    PopupWindow.showErrorMessage("Alert", "No assets selected");
    }

    componentWillReceiveProps(nextprops: any) {

        this.setState({ SelectedDrys: dryData });
        var dryData = nextprops.dryData;
        if (dryData != undefined && dryData != null && dryData.length > 0) {
            this.setState({ RowData: dryData });
        }
    }
    InMotionReportingIntervalChange(event: React.FormEvent<HTMLInputElement>) {
        var filters = this.state.Filters;
        var inMotionReportingInterval = this.state.Filters.InMotionReportingInterval;
        var Value: string = event.currentTarget.value.trim();
        const IsMatch = /^[0-9]*$/;
        if (IsMatch.test(Value))
            inMotionReportingInterval = Value;
        else
            return;
        this.state.Filters.InMotionReportingInterval = inMotionReportingInterval;
        this.setState({ Filters: filters });
    }

 StationaryReportingIntervalChange(event: React.FormEvent<HTMLInputElement>) {
        var filters = this.state.Filters;
        var stationaryReportingInterval = this.state.Filters.StationaryReportingInterval;
        var Value: string = event.currentTarget.value.trim();
        const IsMatch = /^[0-9]*$/;
        if (IsMatch.test(Value))
            stationaryReportingInterval = Value;
        else
            return;
        this.state.Filters.StationaryReportingInterval = stationaryReportingInterval;
        this.setState({ Filters: filters });
    }


    setDefaultFilters() {
        var filters: server.DryForwardCommandParams = {
            SelectedDrys: [], CommandName: "PollUnit", TempValue: "", InMotionReportingInterval: '', StationaryReportingInterval: ''
        };
        return filters;
    }

    public render() {
        return<div>
                 <div className='row mt-2 mb-2'>
                        <div className='col-lg-3 px-0'>
                    <span className='col-form-label mandatory-label'>In-Motion Reporting Interval:</span>
                        </div>
                            <div className='col-lg-3'><input type='text' className='form-control' placeholder='' required onChange={e => this.InMotionReportingIntervalChange(e)} value={this.state.Filters.InMotionReportingInterval} /> </div>
                  
                            <div className='col-lg-3 px-0'>
                    <span className='col-form-label mandatory-label'>Stationary Reporting Interval:</span>
                        </div>
                        <div className='col-lg-3'><input type='text' className='form-control' placeholder='' required onChange={e => this.StationaryReportingIntervalChange(e)} value={this.state.Filters.StationaryReportingInterval} /> </div>
                   </div>
             <DryCommandsGrid selectedDrys={this.state.RowData} commandName={"PollUnit"}></DryCommandsGrid>
            <div className="modal-footer">
                <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
                <button type="button" className="btn btn-primary" onClick={this.submitReportingIntervalCommand.bind(this)}>Save</button>
            </div>
        </div>

    }
}
class ValidationSeverityResult {
    Serverity: string;
    Result: string;
}